export default __webpack_public_path__ + "static/media/The-People-Champ.ae252db0.gif";